import {OnDestroy} from '@angular/core';
import {Subject} from 'rxjs/index';

export class BaseActions implements OnDestroy {

  protected stopSubscription: Subject<boolean> = new Subject<boolean>();
  doneLoading = false;
  hasError: boolean;

  ngOnDestroy(): void {
    this.stopSubscription.complete();
    this.stopSubscription.next(true);
  }

  protected containsErrors(message: string, error?: any): void {
    this.doneLoading = true;
    this.hasError = true;
    console.error(message, error);
  }
}
